var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_FILL0_wght500_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5783 16.4221H7.418C7.01898 16.4221 6.68224 16.2848 6.40778 16.0104C6.13332 15.7359 5.99609 15.3992 5.99609 15.0002C5.99609 14.6012 6.13332 14.2645 6.40778 13.99C6.68224 13.7155 7.01898 13.5783 7.418 13.5783H13.5783V7.418C13.5783 7.01898 13.7155 6.68224 13.99 6.40778C14.2645 6.13332 14.6012 5.99609 15.0002 5.99609C15.3992 5.99609 15.7359 6.13332 16.0104 6.40778C16.2848 6.68224 16.4221 7.01898 16.4221 7.418V13.5783H22.5824C22.9814 13.5783 23.3181 13.7155 23.5926 13.99C23.8671 14.2645 24.0043 14.6012 24.0043 15.0002C24.0043 15.3992 23.8671 15.7359 23.5926 16.0104C23.3181 16.2848 22.9814 16.4221 22.5824 16.4221H16.4221V22.5824C16.4221 22.9814 16.2848 23.3181 16.0104 23.5926C15.7359 23.8671 15.3992 24.0043 15.0002 24.0043C14.6012 24.0043 14.2645 23.8671 13.99 23.5926C13.7155 23.3181 13.5783 22.9814 13.5783 22.5824V16.4221Z",
    fill: "#5534DA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossButton);
export default __webpack_public_path__ + "static/media/cross-button.9223600b2e4a2afecd4b05523a72c045.svg";
export { ForwardRef as ReactComponent };